import database from '../firebase/firebase';
import history from '../Router/history';
import {ShowNotification} from '../components/HandleNotifications'
import { NotificationContainer } from 'react-notifications';

export const jobTypes = {
    CREATE_NEW: "jobs/CREATING_NEW_POST",
    EDIT_DATA: "jobs/EDITING_POST",
    REMOVE_JOBS: "jobs/REMOVING_POST",
    CURRENT_JOB: "jobs/CURRENT_JOB"
};


export const createNewLocal = (payload) => ({
    type: jobTypes.CREATE_NEW,
    payload
});

export const currentJob = (job) => ({
    type:jobTypes.CURRENT_JOB,
    job
})

export const editLocal = (updates, id) => ({
    type: jobTypes.EDIT_DATA,
    updates,
    id
});

export const removeJobs = (newValues) => ({
    type: jobTypes.REMOVE_JOBS,
    newValues
})

export const createNew = (payload = {}, isNew) => {
    return (dispatch, getState) => {
        const uid = getState().auth.uid;
        const {
            jobTitle = '', jobSalary = '', seniority = '',
            data = '', latlang = [], locationName = '',
            vacancyOwner = uid, jobID = '', img = '',
            contract = '', companyName = '', companyAbout = '',
            companyLogo = '', Status = true, Permission= "waiting"
        } = payload

        let sendable = { jobTitle, jobSalary, seniority,
            data, latlang, locationName, vacancyOwner,
            jobID, objectID: jobID, img, contract,
            companyName, companyAbout, companyLogo, Status, Permission
        }

        let publicData = { jobTitle, jobSalary, seniority, data,
            latlang, locationName, vacancyOwner, jobID, objectID: jobID, img,
            contract, companyName, companyAbout, companyLogo, Status, Permission
        }
        database.collection(`vacancies`)
            .doc(jobID)
            .set(publicData, {merge: true})
            .then(() => {
                database.collection(`companies/${uid}/jobs`)
                    .doc(jobID)
                    .set(sendable, {merge: true})
            })
            .then(() => {
                if (isNew) {
                    dispatch(createNewLocal(publicData));
                } else {
                    dispatch(editLocal(publicData, jobID))
                }
            })
            .then(() => {
                history.goBack();
                setTimeout(()=>{
                    ShowNotification('success',`Se agrego la vacante de manera correcta` ,'Todo listo')
                }, 1000)
            })
            .catch((err) => {
                ShowNotification('error', err, 'Hemos encontrado un error en su pedido:')
            })
    }
};